import { Component, OnInit, Input } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent implements OnInit {

  constructor() { }

  vm: ICardHeaderViewModel;

  @Input() title: string = 'card-header';
  @Input() subTitle: string = undefined;
  @Input() subTitleSmall: boolean = true;

  @Input() headingSize: number = 1;

  @Input() helpClass: string = "icon-help";
  @Input() helpHtml: string = undefined;

  @Input() isStandalone: boolean = false;

  helpTriggers: string = "mouseenter:mouseleave:click";
  helpShow: boolean = true;

  ngOnInit() {
    this.vm = { titleText: this.title, subTitleText: this.subTitle, subTitleSmall: this.subTitleSmall, headingSize: this.headingSize };
    if (!this.helpHtml) {
      this.helpTriggers = "";
      this.helpShow = false;
    }
  }
}

/**
 *
 */
interface ICardHeaderViewModel {
  titleText: string;
  subTitleText: string;
  subTitleSmall: boolean;

  headingSize: number;
}

